<template>
  <div>
    <van-cell
      :title="title"
      is-link
      :value="displayValue"
      @click="showPicker = true"
      @cancel="showPicker = false"
    />
    <van-popup class="showBtn" v-model="showPicker" position="bottom" closeable>
      <van-datetime-picker
        :title="title"
        v-model="dateValue"
         type="datetime"
        ref="datetimePicker"
        :item-height="getItemHeight"
        show-toolbar
        @cancel="showPicker = false"
        confirm-button-text=" "
        cancel-button-text=" "
        :class="{ h5picker: $store.state.vantPickeStyle }"
        swipe-duration="350"
      >
        <template #columns-bottom>
          <div
            class="savebtn"
            :class="{
              DatexTabBar: $store.state.iphonex,
              androidTabBar: $store.state.Android,
            }"
            @click="dateStartConfirm"
          >
            确定
          </div>
        </template>
      </van-datetime-picker>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },

    columns: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showPicker: false,
      dateValue: new Date(),
    };
  },
  computed: {
    displayValue() {
      console.log(888888888888, this.value);
      return this.value ? this.value : "请选择";
    },
         getItemHeight() {
    if (this.$store.state.Android || this.$store.state.vantPickeStyle) {
      return '38';
    } else if (this.$store.state.iphonex && screen.height < 860) {
      console.log('14pro');
      return '38';
    } else if (this.$store.state.iphonex && screen.height > 920) {
      console.log('14promax');
      return '42';
    } else {
      return '42';
    }
  }
  },
  methods: {
    dateStartConfirm() {
      // 点击确定按钮事件
      this.$emit("confirm", this.$refs.datetimePicker.value);
      this.showPicker = false;
    },
  },
};
</script>

<style lang="less" scoped>
.van-cell {
  align-items: center;
  padding: 0;
  .h(45);
}
.showBtn {
  // position: relative;
  .h(310);
  .radiusSide(20,20,0,0);

  /deep/ .van-picker__toolbar {
    // .margin(0,0,20,0);
  }

  /deep/ .van-picker__title {
    .fs(16);
    //
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
  }

  .close {
    position: absolute;
    .fs(24);
    color: #999999;
    right: 12px;
    top: 6px;
  }

  /deep/ .savebtn {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    left: 50%;
    transform: translate(-50%, 0);
    .w(343);
    .h(38);
    .radius(12);
    .fs(16);
     bottom: 5px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    background: #a00003;
    z-index: 2;
  }
 /deep/  .androidTabBar {
    bottom: 10px;
  }

  /deep/  .DatexTabBar {
     bottom: 15px;
    // background-color: #999999
  }

  /deep/ .van-picker__columns {
    .h(220) !important;
    .padding(0,0,20,0) !important;
  }
  /deep/ .van-picker {
    .padding(20,0,10,0);
  }
  /deep/ .van-picker__toolbar {
    .h(32);

    .van-picker__title {
      .fs(16);
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
    }
  }
  /deep/.van-picker-column {
    .h(220);

    .van-picker-column__wrapper {
      .h(220);
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/datetimepicker/datetimepicker.vue